export default "__VITE_ASSET__5b52220c__"